import { useSyncExternalStore } from 'react';
import { addOnGlobalSettingsServiceUpdate, GlobalSettingsKeys } from '../../components/Settings';
import { normalizeLocaleString } from '../localeUtils';
import { useLanguage } from '../useTextLocalizer';
import { useOverrideFormatLocale } from './useOverrideFormatLocale';

// Keep a reference to the GlobalSettings so that when useFormatLocale is called after GlobalSettings has initialized
// it doesn't have to wait to get the current value.
let globalSettings;
const novaFormatParam = new URLSearchParams(window.location.search).get('nova-format')?.replace('_', '-')?.toLowerCase();
export const novaFormat = novaFormatParam ? normalizeLocaleString(novaFormatParam) : null;
let init = () => {
  addOnGlobalSettingsServiceUpdate(settings => {
    globalSettings = settings;
  });
  // We only need to initialize once. Overwriting the function means we don't even have to check for initialization on
  // every call to useFormatLocale.
  init = () => {};
};

// Also subscribe to service updates since it is possible to call useFormatLocale before GlobalSettings
// has finished initializing.
const subscribe = changeListener => {
  let settings = null;
  const removeGlobalSettingsServiceUpdate = addOnGlobalSettingsServiceUpdate(s => {
    settings = s;
    changeListener(); // Run changeListener to pick up any new data from the initialized settings.
    settings.registerChangeListener(GlobalSettingsKeys.FORMAT_LOCALE_KEY, changeListener);
  });
  return () => {
    removeGlobalSettingsServiceUpdate();
    settings?.deRegisterChangeListener(GlobalSettingsKeys.FORMAT_LOCALE_KEY, changeListener);
  };
};
const getSnapshot = () => {
  return globalSettings?.get(GlobalSettingsKeys.FORMAT_LOCALE_KEY);
};

/**
 * A way to access the format locale from Global Settings when there is no GlobalSettingsDispatchContext
 * available. The preferred method is to use the regular hooks when the context is available.
 * @param normalize Normalize the locale to use conventions for BCP-47 langauge tags.
 */
export const useFormatLocale = (normalize = true) => {
  init();
  const overrideLocale = useOverrideFormatLocale();
  const formatLocale = useSyncExternalStore(subscribe, getSnapshot);
  const appLocale = useLanguage();
  const locale = novaFormat ?? overrideLocale ?? formatLocale ?? appLocale;
  return normalize ? normalizeLocaleString(locale) : locale;
};
//# sourceMappingURL=useFormatLocale.js.map